import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { TabsModule } from 'primeng/tabs';
import { FreeSwitchIntegrationMainComponent } from 'src/app/features/freeswitch-integration/components/freeswitch-integration-main/freeswitch-integration-main.component';
import { IvrInstanceMainComponent } from 'src/app/features/ivr-instance/components/ivr-instance-main/ivr-instance-main.component';

@Component({
  selector: 'app-instance-management',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    TabsModule,
    FreeSwitchIntegrationMainComponent,
    IvrInstanceMainComponent,
  ],
  templateUrl: './instance-management.component.html',
  styleUrls: ['./instance-management.component.scss'],
})
export class InstanceManagementComponent {
  readonly freeSwitchTab = 'freeswitch';
  readonly ivrTab = 'ivr';
  activeTab = this.freeSwitchTab;
}
